import(/* webpackMode: "eager" */ "/gigooo/app/global-error.tsx");
